const initialState = () => {
  return {};
}

const getters = {};

const mutations = {};

const actions = {
  async addProductToQuote({state, commit, dispatch}, productPayload) {
    const response = await this.$solarClient.post('/api/checkout/quote/addProductToQuote', {
      cartItem: productPayload
    }, { timeout: 25000 });

    window.dispatchEvent(new CustomEvent('CheckoutAddedProductToCartEvent', {
      detail: productPayload['qty']
    }));

    return response;
  }
}

const state = initialState();

const CheckoutQuote = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default CheckoutQuote;
